export const initialPermissions = {
	analytics: {
		view_order_analytics: false,
		view_user_analytics: false,
		view_chip_analytics: false,
		tracking_role_access: [],
	},
	app_settings: {
		manage_settings: false,
		manage_order_settings: false,
		// manage_inventory_settings: false,
		manage_site_settings: false,
		// manage_reminder_settings: false,
		manage_cart_retention: false,
		allow_model_uploads: false,
		manage_price_markups: false,
		manage_line_discounts: false,
		manage_promotions: false,
		access_chatbot: false,
		manage_default_values: false,
	},
	chip_governance: {
		manage_chip_rules: false,
	},
	document_management: {
		view_documents:false,
		download_documents:false,
		create_documents: false,
		update_document_category: false,
		change_document_machine: false,
		edit_documents: false,
		delete_documents: false,
	},
	banner_management: {
		view_banners: false,
		create_banners: false,
		edit_banners: false,
		delete_banners: false,
	},
	promotion_management: {
		view_promotions: false,
		create_promotions: false,
		edit_promotions: false,
		delete_promotions: false,
	},
	line_discount_management: {
		view_line_discounts: false,
		create_line_discounts: false,
		edit_line_discounts: false,
		delete_line_discounts: false,
	},
	machine_provision_management: {
		provision_machines: false,
		edit_provisions: false,
		delete_provisions: false,
	},
	// Deliberately NOT part of recommendations_management above — that category is the customer's
	// own parts lists (add_parts / create_list / ...). This one is the admin Recommendation Approval
	// queue, and the two must stay separate categories because the admin module switch hides a whole
	// category at a time: folding them together would make toggling one module strip the other's
	order_management: {
		create_order: false,
		view_product_price: false,
		add_to_cart: false,
		view_order_history: false,
		create_order_schedules: false,
		edit_order_schedules: false,
		delete_order_schedules: false,
	},
	recommendations_management: {
		create_list: false,
		edit_list: false,
		delete_list: false,
		add_parts: false,
	},
	requests_management: {
		add_to_request_list: false,
		allow_notify_customer_care: false,
		view_request_history: false
	},
	role_management: {
		create_roles: false,
		edit_roles: false,
		delete_roles: false,
	},
	site_management: {
		edit_sites: false,
	},
	service_management: {
		view_cases: false,
		view_workorders: false,
		create_cases: false,
	},
	user_management: {
		assignable_role_types: ["User"],
		assignable_roles: [],
		view_scope: "all",
		edit_scope: "created_by_me",
		delete_scope: "created_by_me",
		site_allocation_scope: "specific_only",
		domain_user_management_scope: "approved_domains_only",
		can_view_pending_users_for_approval: false,
		create_users: false,
		edit_users: false,
		delete_users: false,
	},
	crm_integration: {
		sync_users_to_crm: false,
	},
	profile: {
		allow_password_reset: false,
		allow_notification_preferences: false,
	},
};
